import {
  CLIENT_VIEW_TEMPLATES,
  createDefaultPageContent,
  listTemplatesByCategory,
} from "./clientViewTemplateRegistry";

export const STUDIO_TABS = {
  OVERVIEW: "overview",
  BRANDING: "branding",
  PAGES: "pages",
  DATA: "data",
  MAP: "map",
  CRM: "crm",
  LEAD_BROKER: "lead_broker",
  INTEGRATIONS: "integrations",
  EXTERNAL_API: "external_api",
  ANALYTICS: "analytics",
  EXPERIMENTS: "experiments",
  PWA: "pwa",
  DOMAINS: "domains",
  SEO: "seo",
  CONTENT: "content",
  COMMUNITIES: "communities",
  BOUNDARIES: "boundaries",
  SPONSORSHIP: "sponsorship",
  MONETIZATION: "monetization",
  SEO_CHECKS: "seo_checks",
  PUBLISH: "publish",
  VERSIONS: "versions",
  IAM: "iam",
};

export const STUDIO_TAB_LABELS = {
  [STUDIO_TABS.OVERVIEW]: "Overview",
  [STUDIO_TABS.BRANDING]: "Branding",
  [STUDIO_TABS.PAGES]: "Pages",
  [STUDIO_TABS.DATA]: "Data & Queries",
  [STUDIO_TABS.MAP]: "Map",
  [STUDIO_TABS.CRM]: "CRM",
  [STUDIO_TABS.LEAD_BROKER]: "Lead Broker",
  [STUDIO_TABS.INTEGRATIONS]: "API & Webhooks",
  [STUDIO_TABS.EXTERNAL_API]: "External API",
  [STUDIO_TABS.ANALYTICS]: "Analytics",
  [STUDIO_TABS.EXPERIMENTS]: "Experiments",
  [STUDIO_TABS.PWA]: "PWA",
  [STUDIO_TABS.DOMAINS]: "Domains",
  [STUDIO_TABS.SEO]: "SEO",
  [STUDIO_TABS.CONTENT]: "Content",
  [STUDIO_TABS.COMMUNITIES]: "Communities",
  [STUDIO_TABS.BOUNDARIES]: "Communities & Boundaries",
  [STUDIO_TABS.SPONSORSHIP]: "Sponsorship",
  [STUDIO_TABS.MONETIZATION]: "Monetization",
  [STUDIO_TABS.SEO_CHECKS]: "SEO checks",
  [STUDIO_TABS.PUBLISH]: "Publish",
  [STUDIO_TABS.VERSIONS]: "Activity & Audit",
  [STUDIO_TABS.IAM]: "IAM",
};

export const PAGE_TEMPLATES = CLIENT_VIEW_TEMPLATES.map((entry) => ({
  value: entry.templateKey,
  label: entry.displayName,
  category: entry.category,
  description: entry.description,
}));

export { createDefaultPageContent, listTemplatesByCategory };

export const FONT_ALLOWLIST = [
  "system-ui, sans-serif",
  "Inter, system-ui, sans-serif",
  "Georgia, 'Times New Roman', serif",
  "'Helvetica Neue', Helvetica, Arial, sans-serif",
];

export const LEAD_TYPES = [
  "contact",
  "request_info",
  "schedule_showing",
  "save_search",
  "favorite_listing",
  "newsletter",
  "advertise",
  "agent_referral",
  "general",
];

export function createEmptyPage(sortOrder = 0, templateKey = "content") {
  const meta = CLIENT_VIEW_TEMPLATES.find((entry) => entry.templateKey === templateKey);
  return {
    route: "/",
    template: templateKey,
    title: meta?.displayName || "New page",
    navLabel: meta?.displayName || "New page",
    showInNav: true,
    sortOrder,
    seo: { title: "", description: "" },
    content: createDefaultPageContent(templateKey),
  };
}
